import axios from '../../utils/axios';

type SaveBasicInfoArgs = {
    bundleId: number;
    description: string;
    tags: { label: string }[];
    title: string;
};

export const saveBasicInfo = ({ title, description, tags = [], bundleId }: SaveBasicInfoArgs) =>
    axios.post(`v1/bundle/${bundleId}/basic-info`, {
        description,
        tags: tags.map((t) => t.label),
        title
    });
